export default __webpack_public_path__ + "static/media/Group 3039@2x.30ab1b3c.png";